export class ImageVideoList {
    constructor() {
        window.onload = function() {
            createGrid();

            window.addEventListener('resize', function() {
                createGrid();
            });
        };

        function createGrid() {
            let containers = Array.prototype.slice.call(document.querySelectorAll('.adage-image-video-container-js'));

            containers.forEach(container => {
                let colCount = 2;
                let colHeights = [];

                for (let i = 0; i <= colCount; i++) {
                    colHeights.push(0);
                }
                for (let i = 0; i < container.children.length; i++) {
                    var order = (i + 1) % colCount || colCount;
                    container.children[i].style.order = order;
                    colHeights[order] += parseFloat(container.children[i].offsetHeight + 24);
                }
                let highest = Math.max.apply(Math, colHeights);
                container.style.height = highest + 1 + 'px';
            });
        }
    }
}
